// extracted by mini-css-extract-plugin
module.exports = {"image":"blogpostitem_image__zKdbm","cardItem":"blogpostitem_cardItem__QwhDp"};